// extracted by mini-css-extract-plugin
export default {"currencyRatio":"cV5_pn0gmcJLZCEeM4xW","exRate":"jj4qsYpcW7AdkkwOX9iV"};